// extracted by mini-css-extract-plugin
export default {"textInput":"BadgeConfig-textInput-1b17c53c00d2509a807085304ad2ac43"};